import { authorizedFetchRaw } from './authorizedFetch';
import { DEFAULT_PAGE_SIZE } from '../../constants';

export interface PagedFetchResult<T> {
  results: T[];
  nextUrl?: string;
  total?: string;
}

export interface PagedFetchParams {
  pageSize?: number;
}

type PagedFetch = <T>(path: string, nextUrl?: string, params?: PagedFetchParams) => Promise<PagedFetchResult<T>>;

export const pagedFetch = (baseUrl: Promise<string> | string): PagedFetch => {
  const fetch = authorizedFetchRaw(baseUrl);
  return async <T>(path: string, nextUrl?: string, params?: PagedFetchParams): Promise<PagedFetchResult<T>> => {
    const paging = `page=1&size=${params?.pageSize || DEFAULT_PAGE_SIZE}`;
    const pathWithQueryParams = path.includes('?') ? `${path}&${paging}` : `${path}?${paging}`;

    const url = nextUrl?.substr(1) || pathWithQueryParams;

    const response = await fetch(url, { method: 'GET' });

    return {
      results: await response.json(),
      nextUrl: response.headers.get('x-next'),
      total: response.headers.get('x-total'),
    };
  };
};
